import React from "react";

import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { T } from "services/lang/LanguageService";

type SearchProps = {
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
};

const Search: React.FC<SearchProps> = ({ value, placeholder, onChange }) => {
  return (
    <IconField>
      <InputIcon className="pi pi-search ml-2" />
      <InputText
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={`${placeholder ?? T("action.search")}...`}
        className="px-5"
      />
      <InputIcon className="pi pi-times text-sm cursor-pointer" onClick={() => onChange("")} />
    </IconField>
  );
};

export default Search;
